import { CaseReducer, createSlice, PayloadAction } from "@reduxjs/toolkit";

type initialType = {
  consent: string;
  isBannerExpanded: boolean;
};

type cookieConsentSliceReducer<Payload> = CaseReducer<
  initialType,
  PayloadAction<Payload>
>;

const setConsent: cookieConsentSliceReducer<string> = (state, action) => {
  state.consent = action.payload;
};

const setBannerExpanded: cookieConsentSliceReducer<boolean> = (
  state,
  action
) => {
  state.isBannerExpanded = action.payload;
};

const initialState: initialType = {
  consent: "none",
  isBannerExpanded: false,
};

const cookieConsentSlice = createSlice({
  initialState,
  name: "cookieConsent",
  reducers: {
    setBannerExpanded,
    setConsent,
  },
});

export default cookieConsentSlice;
